import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse, Spin } from "antd";
import { ListTcfNetworkItem } from "./networkItem.js";
import { useListTcfVendor } from "../../../contexts/listTcfVendor.js";
const { Panel } = Collapse;
const ListTcfNetworkSelector = ({ onCreate })=>{
    const contextValue = useListTcfVendor();
    const { adNetworks, view } = contextValue;
    const defaultActiveKeyAdNetwork = (view === "vendors" ? contextValue.defaultCreateAdNetworkIdentifier : undefined) || adNetworks[0].identifier;
    if (contextValue.rows.length === 0) {
        return /*#__PURE__*/ _jsx(Spin, {
            spinning: true
        });
    }
    return /*#__PURE__*/ _jsx(Collapse, {
        accordion: true,
        defaultActiveKey: defaultActiveKeyAdNetwork,
        children: adNetworks.map((adNetwork)=>{
            const { name, identifier, logo } = adNetwork;
            return /*#__PURE__*/ _jsx(Panel, {
                header: name,
                extra: /*#__PURE__*/ _jsx("img", {
                    src: logo,
                    style: {
                        height: "1em"
                    }
                }),
                children: /*#__PURE__*/ _jsx(ListTcfNetworkItem, {
                    ...adNetwork,
                    onCreate: onCreate
                })
            }, identifier);
        })
    });
};
export { ListTcfNetworkSelector };
